/* eslint-disable react/self-closing-comp */
import { useEffect, useState, useCallback } from "react";
import { Row, Col } from "react-flexbox-grid";
import {
  PageWrapper,
  Fab,
  Tab,
  TabPanel,
  VehicleListViewCard,
} from "components";
import { Button } from "components/core";
import { useHistory } from "react-router-dom";
import { withLoader } from "HOC";
import { ReportList } from "pages/private/ReportList";
import { useGlobalContext } from "context/GlobalContext";
import { fetchBackend } from "helpers";

const Vehicles = ({ setLoading }) => {
  const [currentData, setData] = useState([]);
  const history = useHistory();
  const [currentTab, setTab] = useState(0);

  const gContext = useGlobalContext();

  const getCars = useCallback(async () => {
    const id = gContext.currentUser._id;
    const { error, response } = await fetchBackend({ url: `car/user/${id}` });

    if (!error) {
      setData(response);
    } else {
      gContext.toggleAlert({
        message:
          "Hubo un error al intentar obtener los vehículos, revisa tu conexión a internet",
        type: "error",
      });
    }
  }, [gContext.currentUser]);

  const handleChangeTab = (_, newValue) => {
    setTab(newValue);
  };

  const getInitialState = useCallback(async () => {
    const id = gContext.currentUser._id;
    if (id) {
      await Promise.all([getCars()]);
      setLoading(false);
    }
  }, [gContext.currentUser]);

  useEffect(() => {
    getInitialState();
  }, [getInitialState]);

  return (
    <>
      <PageWrapper
        header={
          <>
            <Row start="xs">
              <Col md={12}>
                <Row center="xs">
                  <h1>Mis vehículos</h1>
                </Row>
              </Col>
            </Row>
            <Tab
              tabs={["MIS VEHÍCULOS", "MIS REPORTES"]}
              onChange={handleChangeTab}
              value={currentTab}
            />
          </>
        }
      >
        <TabPanel value={currentTab} index={0}>
          <VehicleListViewCard to="/vehiculos/actualizar" data={currentData} />
          <Row className="mt4">
            <Button
              className="bg-red w-100"
              onClick={() => history.push("/seleccionar-vehiculo")}
            >
              Reportar robo de uno de mis vehículos
            </Button>
          </Row>
        </TabPanel>
        <TabPanel value={currentTab} index={1}>
          <ReportList />
        </TabPanel>
      </PageWrapper>
      <Fab onClick={() => history.push("/vehiculos/agregar")} />
    </>
  );
};

export default withLoader(Vehicles, "Cargando mis vehículos");
